/**
 * 旧版JS行情图翻新
 */

import k from "./k";


module.exports = {
  k: k
} 